import { apiRequest } from './apiClient';

export const getClients = async (search) => {
  const url = search ? `/clients?search=${encodeURIComponent(search)}` : '/clients';
  return apiRequest(url);
};

export const getClient = async (id) => {
  return apiRequest(`/clients/${id}`);
};

export const createClient = async (clientData) => {
  return apiRequest('/clients', { method: 'POST', body: clientData, modelLabel: 'cliente' });
};

export const updateClient = async (id, clientData) => {
  return apiRequest(`/clients/${id}`, { method: 'PUT', body: clientData, modelLabel: 'cliente' });
};

export const deleteClient = async (id) => {
  return apiRequest(`/clients/${id}`, { method: 'DELETE', modelLabel: 'cliente' });
};

export const getPassengers = async (clientId) => {
  return apiRequest(`/clients/${clientId}/passengers`);
};

export const createPassenger = async (clientId, passengerData) => {
  return apiRequest(`/clients/${clientId}/passengers`, {
    method: 'POST',
    body: passengerData,
    modelLabel: 'pasajero',
  });
};

export const updatePassenger = async (id, passengerData) => {
  return apiRequest(`/passengers/${id}`, { method: 'PUT', body: passengerData, modelLabel: 'pasajero' });
};

export const deletePassenger = async (id) => {
  return apiRequest(`/passengers/${id}`, { method: 'DELETE', modelLabel: 'pasajero' });
};
